// Shared API base URL for frontend services
const API_URL =
  process.env.REACT_APP_DEV === 'dev'
    ? process.env.REACT_APP_API_URL
    : process.env.REACT_APP_API_BACKEND_URL;

export default API_URL;
